import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { SlideAnnouncementMutationKeys } from '@/modules/client-setting/keys'
import {
	UpdateSlideAnnouncementRequest,
	UpdateSlideAnnouncementResponse,
} from '@/modules/client-setting/type'
import { updateSlideAnnouncement } from '../../services'

interface UseMutationUpdateSlideAnnouncementProps {
	payload: UpdateSlideAnnouncementRequest
}

export default function useMutationUpdateSlideAnnouncement(
	props?: UseBaseMutationOptions<
		UpdateSlideAnnouncementResponse,
		UseMutationUpdateSlideAnnouncementProps
	>,
) {
	return useMutation({
		mutationKey: [SlideAnnouncementMutationKeys.UpdateSlideAnnouncement],
		mutationFn: (params) => updateSlideAnnouncement(params.payload),
		...props,
	})
}
